import {post} from 'application/api/baseApi';

type Request = {
  prod_id: string;
  prod_groupID: string;
};

type Response = {
  status: 'SUCCESS' | 'FAILURE';
  message: string;
};

const path = '/modifyProductMain';

/**
 * Middleware for {@link post | the generic API "post" function}.
 * @remark Adds type restrictions and the path parameter.
 * @param req Request body
 * @returns Expected response or null
 */
const deleteProductAPI = (req: Request) => post<Response>(
  path,
  {
    ...req,
    prod_itemID: '',
    prod_name: '',
    prod_desc: '',
    prod_price: '',
    prod_dept: '',
    prod_subDept: '',
    prod_superSubDept: '',
    prod_clothingType: '',
    prod_nurseTip: '',
    prod_color: '',
    prod_shipping: '',
    prod_picLG: '',
    prod_picAlt: '',
    prod_picMain: '',
    prod_picSugg: '',
    prod_picThumb: '',
    prod_picThumbA: '',
    taxExempt: '0',
    MFB: 'B',
    imageCount: '',
    hide: '1'
  }
);

export default deleteProductAPI;